import Smartphones from 'Integrations/views/KivraTenantView/containers/Smartphones'
import Tablets from 'Integrations/views/KivraTenantView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const KivraTenantView = getCurrentDeviceView(Smartphones, Tablets)

export default KivraTenantView
